import { NormalizedRegistrationCategory } from '../queries';
import { createContext } from 'react';

interface ContextType {
  categories: NormalizedRegistrationCategory[];
  isRefetching: boolean;
  isLoading: boolean;
  noWeightClass: boolean;
}

export const RegistrationCategoriesContext = createContext<ContextType>({
  isRefetching: false,
  isLoading: false,
  categories: [],
  noWeightClass: false,
});
